import { html, LitElement, unsafeCSS } from "lit-element"
import { classMap } from "lit-html/directives/class-map"
import { styleMap } from "lit-html/directives/style-map"
import style from "./progress.css"

// 円の半径
// これを変更する場合、cssのdynamic-circumferenceも変更する必要がある。
// 値は、r * 2 * 3.15を計算して求める(円周の長さ)
const r = 25

/**
 * 画面排他時のローディング部品
 */
export default class extends LitElement {
	static styles = [unsafeCSS(style)]
	static get properties () {
		return {
			strokeWidth: { type: Number, attribute: "stroke-width" },
			intermediate: { type: Boolean },
			size: { type: Number }
		}
	}

	constructor () {
		super()
		/** @type {number} 線の太さ(直径に対する割合) */
		this.strokeWidth = 5
		/** @type {boolean} 処理中か */
		this.intermediate = false
		/** @type {number} 円の直径(px) */
		this.size = 48
	}

	render () {
		const center = this.#center
		return html`
			<svg class=${this.#progressClass} style=${this.#progressStyle} viewBox=${this.#viewBox} xmlns="http://www.w3.org/2000/svg">
				<circle class="circlar" style=${this.#circleStyle} cx=${center} cy=${center} r=${r} />
			</svg>
    `
	}

	get #progressClass () {
		return classMap({
			progress: true,
			intermediate: this.intermediate
		})
	}

	get #progressStyle () {
		return styleMap({
			height: `${this.size}px`,
			width: `${this.size}px`
		})
	}

	get #circleStyle () {
		return styleMap({
			"stroke-width": this.strokeWidth
		})
	}

	/**
	 * @type {string} svgのviewbox
	 */
	get #viewBox () {
		// stroke-width分を考慮しないと見切れる
		const size = r * 2 + this.strokeWidth
		return `0 0 ${size} ${size}`
	}

	/** @type {number} 円の中心座標(x, y兼用) */
	get #center () {
		return (r * 2 + this.strokeWidth) / 2
	}
}
